import { LiquidSet as StateLS } from 'client/app/apps/disco-prototype/state/liquidSet';
import { convertComponent } from 'client/app/apps/disco-prototype/state/request/convertComponent';
import { convertValue } from 'client/app/apps/disco-prototype/state/request/convertValue';
import { LiquidSet } from 'common/types/disco/liquidSet';

export const convertLiquidSet = (ls: StateLS): LiquidSet => {
  return {
    name: ls.name,
    id: ls.id,
    table: ls.table.id,
    liquidProps: {
      name: convertValue(ls.liquidProps.name),
      volume: convertValue(ls.liquidProps.volume),
      well: convertValue(ls.liquidProps.well),
      plateName: convertValue(ls.liquidProps.plateName),
      composition: ls.liquidProps.composition.map(convertComponent),
    },
  };
};
